import React from 'react';

import RVProfileFilter from '@/components/route/search/RentalFilters/RVProfileFilter/RVProfileFilter';

interface IRVProfileContentProps {
  open?: boolean;
}

const RVProfileContent: React.FC<IRVProfileContentProps> = ({ open }) => {
  return (
    <div className={`p-4 ${open ? 'block' : 'hidden'}`}>
      <RVProfileFilter />
    </div>
  );
};

export default RVProfileContent;
